import { RootState } from '../../modules'

import { TeacherTestState } from './duck'
export const selectTeacherTests = (state: RootState): TeacherTestState =>
  state.teacherTests
